const init = () => {
  $('.modal').modal('show');
};

export default {
  type: 'selector',
  selector: '.show-page-modals',
  init,
};
